// extracted by mini-css-extract-plugin
module.exports = {"image":"CarouselImages_image__2vh2r","h1":"CarouselImages_h1__2chs7","text":"CarouselImages_text__1lDBD","h2":"CarouselImages_h2__CYEmF"};